<template>
  <div>
    <form v-on:submit="save">
      <div class="card card-info">
        <div class="card-header with-border">
          <h3 class="card-title">
            New
          </h3>
        </div>
        <div class="card-body">
          <div class="row" style="margin-top: 7px">
            <div class="col-md-6">
              <label>Employee *</label>
              <select class="form-control" v-model="obj.EmployeeID" v-on:change="employeeChange()">
                <option value="">--Select Employee--</option>
                <option v-for="item in Employees" :value="item.EmployeeRegistrationID">{{item.Name}}</option>
              </select>
            </div>
            <div class="col-md-3">
              <label>Year *</label>
              <select class="form-control" v-model="obj.Year" v-on:change="yearChange()">
                <option value="">--Select Year--</option>
                <option v-for="item in Year" :value="item.Year">{{item.Year}}</option>
              </select>
            </div>
            <div class="col-md-3">
              <label>leave Type* </label>
              <select class="form-control" v-model="obj.LeaveTypeID" required>
                <option value="">--Select Leave Type--</option>
                <option v-for="item in leaves" :value="item.LeaveTypeID">{{item.Name}} (Remaining: {{item.Leaves}})</option>
              </select>
            </div>
            <div class="col-md-6">
              <label>Date From* </label>
              <input class="form-control" v-model="obj.DateFrom" type="date" required />
            </div>
            <div class="col-md-6">
              <label>Date To* </label>
              <input class="form-control" v-model="obj.DateTo" type="date" required />
            </div>
            <div class="col-md-6">
              <label>Approval Date * </label>
              <input class="form-control" v-model="obj.ApprovalDate" type="date" />
            </div>
            <div class="col-md-6">
              <label>Remarks </label>
              <input class="form-control" v-model="obj.Remarks" type="text" maxlength="250" />
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Document</label>
                <div>
                  <input type="file" id="profileimg" v-on:change="onfileupload">
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <br />
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="customCheckbox1" value="option1" v-model="obj.IsApproved">
                <label for="customCheckbox1" class="custom-control-label">Approved</label>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer"> 
            <button class="btn btn-success float-right" type="submit">Save</button>
            <button class="btn btn-danger float-right" style="margin-right:5px" type="button" v-on:click="clear()">Clear</button>
            <button class="btn btn-primary float-left" type="button" v-on:click="back()" >Back to list</button> 
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({ 
    data() {
      return {
        obj: {
          EmployeeID: '',
          LeaveTypeID: '',
          DateFrom: '',
          DateTo: '',
          ApprovalDate: '',
          IsApproved: '',
          Remarks: '',
          Year:''
        },
        img:'',
        Employees: [],
        leaves: [],
        Year:[]
      }
    }, 
    mounted: function () {
      this.pageload(); 
    },
    methods: {
      pageload() {
        var vm = this;
        axios.post('/api/EmployeesApi/pageloadEmployeeleaveRecord')
          .then(function (res) {
            if (res.data.status) {

              vm.Employees = res.data.lst; 
              vm.obj.DateFrom = res.data.dateFrom; 
              vm.obj.DateTo = res.data.dateTo; 
            }
            axios.post('/api/EmployeesApi/checkUpdate')
              .then(function (res) {
                if (res.data.status) { 
                  vm.obj = res.data.edit; 
                  vm.img = res.data.edit.Attachment;
                  axios.post('/api/EmployeesApi/loadEmployeeLeavesYear?empID=' + vm.obj.EmployeeID)
                    .then(function (res) {
                      if (res.data.status)
                        vm.Year = res.data.Year
                      axios.post('/api/EmployeesApi/loadEmployeeLeaves?year=' + vm.obj.Year)
                        .then(function (res) {
                          if (res.data.status)
                            vm.leaves = res.data.leaves
                          endReq();
                        })
                      endReq();
                    })
             
                }
                
                endReq();
              })
          })
      },
        
      
      save(e) {
        e.preventDefault();
        var vm = this;
        if (vm.obj.IsApproved == true && vm.obj.ApprovalDate == "") {
          toastr.error("Select Approval date");
          return;
        }
        startReq();
        axios.post('/api/EmployeesApi/SaveEmployeeLeaveRecord', {
          obj: vm.obj,
          img: vm.img
        })
          .then(function (res) {
            if (res.data.status) {

              toastr.success("Data Saved Successfully!!!");
              setTimeout(function () { window.location.reload() }, 1000);
            }
            else
              toastr.error(res.data.msg); 
            endReq();
          })
      },

      clear() {
         window.location.reload();
      },
      employeeChange() {
        var vm = this;
        startReq();
        axios.post('/api/EmployeesApi/loadEmployeeLeavesYear?empID=' + vm.obj.EmployeeID)
          .then(function (res) {
            if (res.data.status)
              vm.Year = res.data.Year
            endReq();
          })
      },
      yearChange() {
        var vm = this;
        startReq();
        axios.post('/api/EmployeesApi/loadEmployeeLeaves?year=' + vm.obj.Year)
          .then(function (res) {
            if (res.data.status)
              vm.leaves = res.data.leaves
            endReq();
          })
      },
      checkFile(file) {
        if (file == null) {
          return false;
        }

        if (file.size > 50000000000) {
          toastr.error("file size is large maximum 500 kb allowed", "Error!");

          return false;
        }

        //if (file.type != "image/jpeg" && file.type != "image/png") {
        //  toastr.error("Invalid File! only JPG and PNG is allowed");
        //  return false;
        //}

        return true;
      },
      back() {
        window.location.href = "../Employees/EmployeeLeavesRecordIndex";
      },
      onfileupload: function (event) {
        if (this.checkFile(event.target.files[0])) {
          startReq();
          var image = new Image;
          var reader = new FileReader;
          reader.onload = (e) => {
            this.img = e.target.result
            //this.sendImg(this.img);
          }
          reader.readAsDataURL(event.target.files[0]);
          endReq();
        }
        else {
          $('#profileimg').val('');
        }
      },
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/hr/employeeLeavesRecord.vue